import { useDevice } from '@/contexts/DeviceContext';

export const useUserDevice = () => {
  const { selectedDevice } = useDevice();
  
  return {
    device: selectedDevice,
    jssid: selectedDevice?.jssid,
    isLoading: false,
    error: null
  };
};